import TickerService from '@resn/gozer-services/ticker-service';

const TextureCache = new Map();

let _gl;

const pushingQueue = [];
const queue = (d, done) => {
    pushingQueue.push({ d, done });
};

const checkQueue = () => {
    if (pushingQueue.length) {
        const { d, done } = pushingQueue.pop();
        done();
    }
};

TickerService.add(checkQueue);

export function setContextLoadTexture(gl) {
    _gl = gl;
}

export default function loadTexture(url) {
    if (!_gl) throw new Error('loadTexture not initialised');

    if (TextureCache.has(url)) {
        return Promise.resolve(TextureCache.get(url));
    }

    return import('ogl')
        .catch(() => {
            console.warn('Could not load TextureLoader, is ogl installed?');
        })
        .then(({ TextureLoader }) => {
            return new Promise((resolve) => {
                const d = TextureLoader.load(_gl, { src: url.split('#')[0] });
                queue(d, () => {
                    resolve(d);
                });
                TextureCache.set(url, d);
            });
        });
}
